export default {
  methods: {
    hasAccess(permissionRequested, operation) {
      // Verifica se os parâmetros são fornecidos
      if (!permissionRequested || !operation) {
        return false;
      }

      // Se tiver acesso de Desenvolvedor ou Administrador, consequentemente tem acesso a todas telas
      if (['dev', 'admin'].includes(this.$auth.user().acesso_interno)) {
        return true;
      }

      // Se não tiver nenhum acesso relacionado ao usuário, consequentemente não tem acesso a nenhuma tela
      if (!this.$auth.user().acesso) {
        return false;
      }

      // Tenta analisar as permissões, se falhar, retorna falso
      let permissions;
      try {
        permissions = JSON.parse(this.$auth.user().acesso.permissoes);
      } catch (e) {
        return false;
      }

      // Encontra a permissão solicitada
      const permission = permissions.find(item => item.key === permissionRequested);

      // Verifica se a permissão e a operação existem
      return permission && (permission[operation] === true || permission[operation] === 1);
    },

    hasCondominioAccess(permissionRequested, operation, condominio_id = this.editedItem.condominio_id) {
      // Se tiver acesso de Desenvolvedor ou Administrador, consequentemente tem acesso a todas telas
      if (['dev', 'admin'].includes(this.$auth.user().acesso_interno)) { return true }

      let condominio_user = this.$auth.user().acessos_condominios.find(item => item.condominio_id === condominio_id)

      // Se não encontrar nenhum acesso, retorna falso e bloqueia o acesso
      if (!condominio_user) { return false }

      const permissions = JSON.parse(condominio_user.acesso.permissoes)

      const permission = permissions.find(item => item.key === permissionRequested)

      if (!permission) { return false }

      return (permission[operation] === true || permission[operation] === 1)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/acl.js